import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import Header from './components/Header';
import AboutContent from './components/AboutContent';
import SecondPage from './components/SecondPage';
import ThirdPage from './components/ThirdPage';
import { theme } from './styles/theme';
import { imageSetForPNG } from '../utils/imageset';
// import backgroundImage from '/images/Greek40.png';

const backgroundImage = '/images/Greek40.png';

function About({ onNavigate }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '300vh',
          display: 'flex',
          flexDirection: 'column',
          backgroundImage: imageSetForPNG(backgroundImage),
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          overflowX: 'hidden',
          '&::before': {
            content: '""',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            zIndex: 0,
          }
        }}
      >
        <Header /> {/* 顶部导航和语言切换 */}
        <AboutContent onNavigate={onNavigate} />
        <SecondPage />
        <ThirdPage />
      </Box>
    </ThemeProvider>
  );
}

export default About; 